export const DEFAULT_AI_MODEL_ID = "openai/gpt-5.6-luna";

export const FEATURED_AI_MODEL_IDS = [
  "openai/gpt-5.6-luna",
  "google/gemma-4-26b-a4b-it",
  "deepseek/deepseek-v4-flash",
  "openrouter/free",
] as const;

export type AiModelId = string;

export const FEATURED_AI_MODEL_LABELS: Record<string, string> = {
  "google/gemma-4-26b-a4b-it": "Gemma 4",
  "deepseek/deepseek-v4-flash": "DeepSeek V4 Flash",
  "openai/gpt-5.6-luna": "GPT-5.6 Luna",
  "openrouter/free": "Free Models Router",
};
export const FEATURED_AI_MODEL_DESCRIPTIONS: Record<string, string> = {
  "openai/gpt-5.6-luna": "Modelo padrão para análises mais refinadas.",
  "google/gemma-4-26b-a4b-it": "Modelo compacto para conversas do dia a dia.",
  "deepseek/deepseek-v4-flash": "Rápido e econômico para perguntas frequentes.",
  "openrouter/free":
    "Roteador oficial do OpenRouter para modelos gratuitos (admin).",
};

export const isFreeModelId = (id: string) =>
  id.endsWith(":free") || id === "openrouter/free";
// Compatibility metadata for the current server-rendered chat shell. The
// authoritative availability check is the dynamic OpenRouter catalog.
export const AI_MODELS = FEATURED_AI_MODEL_IDS.map((id) => ({
  id,
  label: FEATURED_AI_MODEL_LABELS[id],
  description: "Modelo disponível no OpenRouter.",
  contextWindow: null,
  adminOnly: false,
})) as unknown as Array<{
  id: string;
  label: string;
  description: string;
  contextWindow: number | null;
  adminOnly: boolean;
}>;

export const isAiModelId = (modelId: string): modelId is AiModelId =>
  modelId.trim().length > 0;
